define('controller/template/template.history.controller',['require','exports','module','fukit','view/template/template.history.page.view','formkit/formkit','model/revision.model','model/template.preview.model','fukit'],function(require, exports, module) {
  //prettier-ignore
  var BaseController       = require('fukit').BaseController,
      RevisionHistoryPage  = require('view/template/template.history.page.view'),
      FormKit              = require('formkit/formkit'),
      RevisionModel        = require('model/revision.model'),
      TemplatePreviewModel = require('model/template.preview.model'),
      ROLES                = require('fukit').Roles;

  var TemplateHistoryController = BaseController.extend({
    radioRequests: {
      'controllers TemplateHistoryController': '@constructor',
    },

    pageView: RevisionHistoryPage,

    pageViewOptions: function() {
      return {
        form: this.createForm(),
      };
    },

    stateConfiguration: {
      defaults: {
        roles: [ROLES.COI_EFORM_TEMPLATE_ACCESS],
      },
    },

    resources: {
      template: {
        model: TemplatePreviewModel,
      },
      revision: {
        model: RevisionModel,
        attrs: {
          id: '@state.revisionId',
        },
      },
      revisionsHistory: {
        collection: RevisionModel.Collection,
      },
    },

    createForm: function() {
      var template = this.getResource('template');

      var form = new FormKit.Form({
        templateModel: template,
      });

      this.listenTo(form, 'end:edit:answer', function() {
        template.save();
      });

      return form;
    },

    onStart: function() {
      this.listenTo(this.getResource('revision'), 'sync', this.onRevisionResourceSync);
      this.fetchResource('revision');

      var revisionHistoryCollection = this.getResource('revisionsHistory');

      revisionHistoryCollection.paginate.size(20);
      revisionHistoryCollection.paginate.page(this.state.get('revisionsPageNumber'));

      revisionHistoryCollection.sort.field('publishedDate').makeDescending();
      revisionHistoryCollection.filters.add({ field: 'template.id', value: this.state.get('templateId') });

      revisionHistoryCollection.fetch();
    },

    onRevisionResourceSync: function(model, resp, options) {
      var revisionModel = this.getResource('revision');
      var templateModel = this.getResource('template');
      templateModel.set(revisionModel.get('json'));
      templateModel.save();
    },
  });
  module.exports = TemplateHistoryController;
});

